import Layout from '../components/Layout';
import Container  from 'react-bootstrap/Container';
function Shoping() {
    return (
        <>
            <Layout>
            <Container>
                Shoping
            </Container>
            </Layout>
        </>
    );
}

export default Shoping;